import React from 'react'
import { Panel, SelectFieldIcon, TextFieldIcon } from '../../../_components'

let season = localStorage.getItem( "season" )
let operation = localStorage.getItem( "operation" )

export default function Main( { values, handleChange, handleBlur } ) {
    // console.log( localStorage.getItem( "operation" ));
    // console.log( localStorage.getItem( "season" ));

    return (
    <>
        <Panel label="Farmer Bio Data">
        <div className="grid grid-cols-5 gap-2">
            <TextFieldIcon 
                name="name"
                type="text"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.name}
                label="Farmer Name"
                disabled={true}
                required={false}
                question="Farmer Name"
            />

            <TextFieldIcon 
                name="block_number"
                type="text"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.block_number}
                label="Block Number"
                disabled={true}
                required={false}
                question="Block Number"
            />

            <TextFieldIcon 
                name="ffsg_number"
                type="text"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.ffsg_number}
                label="FFSG Number"
                disabled={true}
                required={false}
                question="FFSG Number"
            />

            <TextFieldIcon 
                name="plot_number"
                type="text"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.plot_number}
                label="Plot Number"
                disabled={true}
                required={false}
                question="Plot Number"
            />

            <TextFieldIcon 
                name="contact"
                type="text"
                handleChange={handleChange} 
                handleBlur={handleBlur}
                value={values.contact}
                label="Contact"
                disabled={true}
                required={false}
                question="Contact"
            />
        </div>
        </Panel>

        <Panel label="Season">
            <div className="grid grid-cols-2 gap-2">
                <SelectFieldIcon 
                    name="season"
                    handleChange={handleChange} 
                    handleBlur={handleBlur}
                    value={values.season}
                    label="Season"
                    required={true}
                    question="Choose Season"
                    options={[
                        { id: 1, season: 1, value: "NovApril23", label: "Nov-April -2022/2023"},
                        { id: 2, season: 2, value: "MaySept23", label: "May-Sept - 2023"}
                    ].filter( item => {
                        if(  season === "season1" ) {
                            return item.season === 1
                        }
                        if( season === "season2") {
                            return item.season === 2
                        }
                        return item
                    } )}
                />
            </div>
        </Panel>
    </>
   
  )
}
